function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".unlocked_svg__st0{fill:#c92a34}");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "unlocked_svg__fab-call"
}, /*#__PURE__*/React.createElement("path", {
  className: "unlocked_svg__st0",
  d: "M9.4 51.9h10.3c2.7 0 3.2-1.9 3.2-4.1v-7.3c0-9.6 8.7-15.9 17-15.9s16.6 5.5 16.6 15.9v7.6c0 2.5 1 3.7 3.6 3.7h9.7c3.1 0 4-1.9 4-3.8v-7.5C73.8 22 58.6 8.1 40 8.1S6.3 22 6.3 40.6v7.6c0 1.5.9 3.7 3.1 3.7zM126.7 63.4H57.6c-6.2 0-11.8 4.8-11.8 11v55.1c0 6.2 5.5 11.9 11.8 11.9h69.1c6.2 0 11.6-5.7 11.6-11.9V74.4c0-6.2-5.3-11-11.6-11zm-28.1 40.7v15c0 1.9-.3 3.4-2.2 3.4h-8.5c-1.8 0-2.2-1.9-2.2-3.4v-15c-3.9-2.2-5.4-5.8-5.4-10 0-6.7 5.3-12.2 12-12.2S104 87.4 104 94.1c.1 4.1-1.6 7.8-5.4 10z"
}));

var SvgUnlocked = function SvgUnlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "unlocked_svg__Layer_2",
    x: 0,
    y: 0,
    viewBox: "0 0 150 150",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default SvgUnlocked;